import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Footer from "../footer/Footer";
import Navbar from "../navbar/Navbar";
import AboutLeftTab from "../About/AboutLeftTab";
import axios from "axios";

const NewsDetails = () => {

    const { id } = useParams();
    const [news, setNews] = useState(null);

    useEffect(() => {
        fetchNews();
    }, [id]);

    // ✅ Convert .NET date
    const parseDotNetDate = (dateStr) => {
        if (!dateStr) return null;
        const timestamp = dateStr.match(/\d+/)[0];
        return new Date(parseInt(timestamp));
    };

    // ✅ Convert YouTube URL → embed
    const getYoutubeEmbedUrl = (url) => {
        if (!url) return null;

        const match = url.match(
            /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^?&]+)/
        );

        return match
            ? `https://www.youtube.com/embed/${match[1]}`
            : null;
    };

    const fetchNews = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}/Home/GetNewsDetailsApi/${id}`
            );

            if (res.data.status === "Success") {

                const item = res.data.data;

                setNews({
                    id: item.Id,
                    title: item.Tittle,
                    subtitle: item.Sub_Tittle,
                    description: item.News_Content,
                    images: item.Images ? item.Images.split(",") : [],
                    file: item.Files,
                    video: item.Video_Url,
                    date: parseDotNetDate(item.Date)
                });
            }

        } catch (error) {
            console.error("Error fetching News:", error);
        }
    };

    if (!news) {
        return (
            <div>
                <Navbar />
                <div className="text-center my-5">Loading...</div>
                <Footer />
            </div>
        );
    }

    return (
        <div>
            <Navbar />

            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">

                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">

                            <div className="how-to-apply">

                                <h2>{news.title}</h2>

                                {/* ✅ Subtitle */}
                                {news.subtitle && (
                                    <h5 className="text-muted">{news.subtitle}</h5>
                                )}

                                

                                {/* ✅ Description */}
                                <div className="py-3">
                                    <p style={{ whiteSpace: "pre-line" }}>
                                        {news.description}
                                    </p>
                                </div>

                                {/* ✅ YouTube Video */}
                                {news.video && getYoutubeEmbedUrl(news.video) && (
                                    <div className="my-4">
                                        <iframe
                                            width="100%"
                                            className="sixteen-nine rounded"
                                            src={getYoutubeEmbedUrl(news.video)}
                                            title="YouTube video"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                )}

                                {/* ✅ Images */}
                                {news.images.length > 0 && (
                                    <div className="row">
                                        {news.images.map((img, index) => (
                                            <div key={index} className="col-md-6 mb-3">
                                                <img
                                                    src={`${process.env.REACT_APP_API_URL}${img}`}
                                                    alt={news.title}
                                                    className="img-fluid"
                                                />
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {/* ✅ File Download */}
                                {news.file && (
                                    <div className="mt-4">
                                        <a
                                            href={`${process.env.REACT_APP_API_URL}${news.file}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-danger"
                                        >
                                            Download Attachment
                                        </a>
                                    </div>
                                )}

                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default NewsDetails;